// extracted by mini-css-extract-plugin
export default {"search":"CalendarSearch_search__SmS-W"};